import type { ImageryLayer, Viewer } from 'cesium'
import type { BaseLayerI } from '.'
import { GeoserverWMSProvider } from '../GeoserverWMSProvider'

export abstract class WmsBaseLayer implements BaseLayerI {
  abstract layername: string
  abstract key: string
  private imageLayer?: ImageryLayer
  private viewer?: Viewer
  abstract provider: GeoserverWMSProvider
  mount(viewer: Viewer): void {
    this.viewer = viewer
  }
  show(): void {
    if (!this.viewer) return
    if (!this.imageLayer) {
      this.imageLayer = this.viewer.imageryLayers.addImageryProvider(this.provider)
    }
    this.imageLayer.show = true
  }
  hide(): void {
    if (!this.imageLayer) return
    this.imageLayer.show = false
  }
  destroyLayer(): void {
    this.imageLayer?.destroy()
    this.imageLayer = undefined
  }
}
